/* global jQuery COMPONENTS */

COMPONENTS.ComponentCookieBar = (function ($) {
  function ComponentCookieBar () {
    this.$component = $('[data-ecs-component="component-cookiebar"]')
    this.$siteUrl = this.$component.attr('[data-ecs-cookiebar-siteurl]')
    this.$bannerToggles = this.$component.find('[data-ecs-components-control="cookiebanner-toggle"]')
  }

  ComponentCookieBar.prototype.init = function () {
    const component = this

    COMPONENTS.utility = new COMPONENTS.Utility()

    component.$bannerToggles.each(function () {
      // Toggle the banner when the close button is clicked, set the cookie indicating the banner has been viewed
      $(this).click(function () { // A banner toggle button is clicked
        $(component.$component).slideUp() // close banner
        COMPONENTS.utility.setCookie('_componentsCookiesBanner', '1', 60, (component.$siteUrl + '/')) // set cookie
      })
    })

    // Hide the banner on load if the cookie is present (the user has clicked the close button before)
    if (COMPONENTS.utility.getCookieValue('_componentsCookiesBanner') >= 1) {
      $(component.$component).hide() // hide banner
    }
  }

  return ComponentCookieBar
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Hook into the main components init
  COMPONENTS.ComponentCookieBar = new COMPONENTS.ComponentCookieBar()
  COMPONENTS.ComponentCookieBar.init()
})
